interface assetsAndCommitmentsLang {
  securities: string;
  loan: string;
  assets: string;
  commitments: string;
  assetsCommitmentsTitle: string;
  creditCard: string;
  mortgage: string;
  deposit: string;
  checkingAccount: string;
  foreighnCurrency: string;
  productsTitle: string;
  pageBreadcrumb: string;
  manageAssetsTitle: string;
  addAsset: string;
  exportShort: string;
  summaryTitle: string;
  assetsChartTitle: string;
  sunburstChartTitle: string;
  currencyChartTitle: string;
  category: string;
  filterBy: string;
  searchPlaceholder: string;
  customizeColumnsText: string;
  customizeFields: string;
  showColumns: string;
  subCustomizeColumnsText: string;
  name: string;
  accountNumber: string;
  baseCurrency: string;
  baseDebt: string;
  originalCurrency: string;
  lastUpdateDate: string;
  updatedOn: string;
  familyJointDuplicateHint: string;
  currentYield: string;
  yieldFromStartOfActivity: string;
  ownership: string;
  expectedYield: string;
  liquidity: string;
  profit: string;
  managementFee: string;
  partOfPortfolio: string;
  moreDetails: string;
  monthlyChange: string;
  dailyChange: string;
  rsuAndOptions: string;
  expectedMonthlyGrowth: string;
  bankCategory: string;
  nadlanCategory: string;
  kupotCategory: string;
  kriptoCategory: string;
  honCategory: string;
  debtCategory: string;
  otherCategory: string;
  cleanButton: string;
  restoreDefaultButton: string;
  saveButton: string;
  investedCapital: string;
  nonInvestedCapital: string;
  noAssetsmessageTitle: string;
  noAssetsMessageContent: string;
  noAssetsMessageButton: string;
  maslekaStatusText: {
    bold: string;
    pending: string;
    ready: string;
    failed: string;
    expired: string;
  };
}

interface assetsAndCommitmentsType {
  HEB: assetsAndCommitmentsLang;
  ENG: Partial<assetsAndCommitmentsLang>;
  RUS?: Partial<assetsAndCommitmentsLang>;
}

export const assetsAndCommitments: assetsAndCommitmentsType = {
  HEB: {
    securities: "ניירות ערך",
    deposit: "פקדון",
    loan: "הלוואה",
    creditCard: "כרטיס",
    mortgage: "משכנתא",
    assets: "נכסים",
    commitments: "התחייבויות",
    assetsCommitmentsTitle: "נכסים והתחייבויות",
    checkingAccount: 'עו"ש',
    foreighnCurrency: 'מט"ח',
    productsTitle: "כאן ניתן לנהל את המידע שלך",
    pageBreadcrumb: "התיק שלי",
    manageAssetsTitle: "ניהול התיק שלי",
    addAsset: "הוספת נכס",
    exportShort: "ייצוא",
    summaryTitle: "סיכום נכסים והתחייבויות שבבעלותך",
    assetsChartTitle: "הון מושקע ולא מושקע",
    sunburstChartTitle: "מפת הנכסים שלכם",
    currencyChartTitle: "התפלגות מטבעות",
    category: "קטגוריה",
    filterBy: "סנן לפי",
    searchPlaceholder: "חיפוש לפי כינוי או שווי",
    customizeColumnsText: "התאמה אישית של העמודות",
    customizeFields: "התאמת שדות",
    showColumns: "הצג עמודות",
    subCustomizeColumnsText: "לא ניתן לבחור יותר מ-9 קריטוריונים",
    name: "כינוי",
    accountNumber: "מספר חשבון",
    baseCurrency: "שווי נוכחי",
    baseDebt: "חוב כולל",
    originalCurrency: "שווי נוכחי במטבע מקורי",
    lastUpdateDate: "תאריך עדכון אחרון",
    updatedOn: "עודכן",
    familyJointDuplicateHint: "אותו חשבון כבר מחובר בתיק המשפחתי — נספר פעם אחת",
    currentYield: "תשואה שנתית נוכחית",
    yieldFromStartOfActivity: "תשואה מתחילת הפעילות",
    ownership: "חלק הבעלות בנכס",
    expectedYield: "עליית ערך צפויה",
    liquidity: "נזילות",
    profit: "רווח/הפסד",
    managementFee: "דמי ניהול מחיסכון",
    partOfPortfolio: "חלק יחסי בתיק",
    moreDetails: "פרטים נוספים",
    monthlyChange: "שינוי חודשי",
    dailyChange: "שינוי יומי",
    expectedMonthlyGrowth: "צמיחה חודשית צפויה",
    bankCategory: "בנק",
    nadlanCategory: "נדלן",
    kupotCategory: "קופות ופנסיות",
    kriptoCategory: "קריפטו",
    honCategory: "שוק ההון",
    rsuAndOptions: "ואופציות RSU",
    debtCategory: "הלוואות",
    otherCategory: "אחר",
    cleanButton: "נקה",
    restoreDefaultButton: "שחזר ברירת מחדל",
    saveButton: "שמירה",
    investedCapital: "הון מושקע",
    nonInvestedCapital: "הון לא מושקע",
    noAssetsmessageTitle: "בוא נמקסם יחד את המצב הפיננסי שלך",
    noAssetsMessageContent:
      "כל מה שעליך לעשות זה להכניס את פרטי הנכסים וההלוואות שלך, ככל שיותר מידע יוזן במערכת, אנחנו נוכל לספק לך יותר מידע שיופיע בדאשבורד.",
    noAssetsMessageButton: "שנתחיל?",
    maslekaStatusText: {
      bold: "סטטוס מסלקה: ",
      pending:
        "הנכסים הפנסיונים שלך בדרך! אנו ממתינים שהם יגיעו מהמסלקה הפנסיונית.",
      ready: "הנכסים הפנסיונים שלך הגיעו! ניתן לראות אותם בטבלה.",
      failed:
        "הייתה בעיה בייבוא המוצרים מהמסלקה, אנא פנו לשירות הלקוחות במייל office@moneytor.co.il.",
      expired:
        "תוקף המסלקה שלך פג! יש לחדש את המסלקה כדי לקבל עדכונים חדשים על הנכסים הפנסיונים שלך.",
    },
  },
  ENG: {
    securities: "Securities",
    deposit: "Deposit",
    loan: "Loan",
    creditCard: "Credit card",
    mortgage: "Mortgage",
    assets: "Assets",
    commitments: "Liabilities",
    assetsCommitmentsTitle: "Assets & Liabilities",
    checkingAccount: "Checking",
    foreighnCurrency: "Foreign currency",
    productsTitle: "Manage your financial data here",
    pageBreadcrumb: "My portfolio",
    manageAssetsTitle: "Managing my portfolio",
    addAsset: "Add asset",
    exportShort: "Export",
    summaryTitle: "Summary of your assets and liabilities",
    assetsChartTitle: "Invested Capital",
    sunburstChartTitle: "Your asset map",
    currencyChartTitle: "Currency distribution",
    category: "Category",
    filterBy: "Filter by",
    searchPlaceholder: "Search by nickname or value",
    customizeColumnsText: "Customize columns",
    customizeFields: "Customize fields",
    showColumns: "Show columns",
    subCustomizeColumnsText: "Cannot select more than 9 criteria",
    name: "Nickname",
    accountNumber: "Account number",
    baseCurrency: "Current value",
    baseDebt: "Total debt",
    originalCurrency: "Current value in original currency",
    lastUpdateDate: "Last update date",
    updatedOn: "Updated",
    familyJointDuplicateHint:
      "The same account is already connected in the family portfolio — counted once",
    currentYield: "Current annual yield",
    yieldFromStartOfActivity: "Yield from start of activity",
    ownership: "Asset ownership share",
    expectedYield: "Expected value increase",
    liquidity: "Liquidity",
    profit: "Profit/Loss",
    managementFee: "Savings management fee",
    partOfPortfolio: "Relative portfolio share",
    moreDetails: "More details",
    monthlyChange: "Monthly change",
    dailyChange: "Daily change",
    expectedMonthlyGrowth: "Expected monthly growth",
    bankCategory: "Bank",
    nadlanCategory: "Real Estate",
    kupotCategory: "Pensions & Funds",
    kriptoCategory: "Crypto",
    honCategory: "Capital Markets",
    rsuAndOptions: "RSU & Options",
    debtCategory: "Loans",
    otherCategory: "Other",
    cleanButton: "Clear",
    restoreDefaultButton: "Restore defaults",
    saveButton: "Save",
    investedCapital: "Invested capital",
    nonInvestedCapital: "Non-invested capital",
    noAssetsmessageTitle: "Let's maximize your financial situation together",
    noAssetsMessageContent:
      "All you need to do is enter your asset and loan details. The more data you provide, the more insights we can show you on the dashboard.",
    noAssetsMessageButton: "Let's start!",
    maslekaStatusText: {
      bold: "Masleka status: ",
      pending:
        "Your pension assets are on the way! We are waiting for them to arrive from the Pension Clearinghouse.",
      ready:
        "Your pension assets have arrived! You can view them in the table.",
      failed:
        "There was a problem importing products from the Clearinghouse. Please contact support at office@moneytor.co.il.",
      expired:
        "Your Masleka has expired! Please renew to receive updated information about your pension assets.",
    },
  },
  RUS: {
    securities: "Ценные бумаги",
    deposit: "Депозит",
    loan: "Кредит",
    creditCard: "Карта",
    mortgage: "Ипотека",
    assets: "Активы",
    commitments: "Обязательства",
    assetsCommitmentsTitle: "Активы и обязательства",
    checkingAccount: "Расчётный счёт",
    foreighnCurrency: "Иностранная валюта",
    productsTitle: "Управление финансовыми данными",
    pageBreadcrumb: "Мой портфель",
    manageAssetsTitle: "Управление активами",
    addAsset: "Добавить актив",
    exportShort: "Экспорт",
    summaryTitle: "Сводка активов и обязательств",
    assetsChartTitle: "Инвестированный капитал",
    sunburstChartTitle: "Карта ваших активов",
    currencyChartTitle: "Распределение по валютам",
    category: "Категория",
    filterBy: "Фильтровать по",
    searchPlaceholder: "Поиск по названию или стоимости",
    customizeColumnsText: "Столбцы",
    customizeFields: "Настройка полей",
    showColumns: "Показать столбцы",
    subCustomizeColumnsText: "Не более 9 критериев",
    name: "Название",
    accountNumber: "Номер счёта",
    baseCurrency: "Текущая стоимость",
    baseDebt: "Общий долг",
    originalCurrency: "Стоимость в валюте",
    lastUpdateDate: "Дата обновления",
    updatedOn: "Обновлено",
    familyJointDuplicateHint:
      "Этот счёт уже подключён в семейном портфеле — учитывается один раз",
    currentYield: "Годовая доходность",
    yieldFromStartOfActivity: "Доходность с начала",
    ownership: "Доля в активе",
    expectedYield: "Ожид. рост",
    liquidity: "Ликвидность",
    profit: "Прибыль/Убыток",
    managementFee: "Комиссия",
    partOfPortfolio: "Доля в портфеле",
    moreDetails: "Подробнее",
    monthlyChange: "За месяц",
    dailyChange: "За день",
    expectedMonthlyGrowth: "Рост (мес.)",
    bankCategory: "Банк",
    nadlanCategory: "Недвижимость",
    kupotCategory: "Пенсии и фонды",
    kriptoCategory: "Крипто",
    honCategory: "Фондовый рынок",
    rsuAndOptions: "RSU и опционы",
    debtCategory: "Кредиты",
    otherCategory: "Другое",
    cleanButton: "Очистить",
    restoreDefaultButton: "Восстановить по умолчанию",
    saveButton: "Сохранить",
    investedCapital: "Инвестированный капитал",
    nonInvestedCapital: "Неинвестированный капитал",
    noAssetsmessageTitle: "Оптимизируем ваши финансы вместе",
    noAssetsMessageContent:
      "Введите данные об активах и кредитах. Чем больше данных — тем больше аналитики на панели.",
    noAssetsMessageButton: "Начнём?",
    maslekaStatusText: {
      bold: "Статус Маслека: ",
      pending:
        "Ваши пенсионные активы в пути! Мы ожидаем их поступления из Пенсионной клиринговой палаты.",
      ready:
        "Ваши пенсионные активы получены! Вы можете просмотреть их в таблице.",
      failed:
        "Возникла проблема при импорте продуктов из клиринговой палаты. Пожалуйста, обратитесь в службу поддержки.",
      expired:
        "Срок действия вашей Маслека истёк! Обновите её, чтобы получать актуальную информацию о ваших пенсионных активах.",
    },
  },
} as const;
